// extracted by mini-css-extract-plugin
module.exports = {"text":"_Qyn7o_ck"};